import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';

import './index.css';
import App from './components/App/App';
import * as serviceWorker from './serviceWorker';
import store from './store/store';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-TZCZZHNC',
};

TagManager.initialize(tagManagerArgs);

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
